/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone } from '@angular/core';
import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';

import { Components } from '@imv/ui-kit';

import { Autocomplete as IAutocomplete } from '@imv/ui-kit/dist/types/components/autocomplete/component/autocomplete';
export declare interface ImvUiAutocomplete extends Components.ImvUiAutocomplete {}
@ProxyCmp({
  inputs: ['disabled', 'dynamicStyle', 'eid', 'label', 'maxLength', 'optionalLabel', 'placeholder', 'required', 'showErrors', 'suggestionlist', 'value', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-autocomplete',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'dynamicStyle', 'eid', 'label', 'maxLength', 'optionalLabel', 'placeholder', 'required', 'showErrors', 'suggestionlist', 'value', 'variant'],
  outputs: ['changeValue']
})
export class ImvUiAutocomplete {
  /**  */
  changeValue!: IAutocomplete['changeValue'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['changeValue']);
  }
}

import { BoxLink as IBoxLink } from '@imv/ui-kit/dist/types/components/box-link/component/box-link';
export declare interface ImvUiBoxLink extends Components.ImvUiBoxLink {}
@ProxyCmp({
  inputs: ['ariaLabel', 'draft', 'eid', 'extraIcon', 'first', 'href', 'literals', 'size', 'theme', 'variant']
})
@Component({
  selector: 'imv-ui-box-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['ariaLabel', 'draft', 'eid', 'extraIcon', 'first', 'href', 'literals', 'size', 'theme', 'variant'],
  outputs: ['eventChange']
})
export class ImvUiBoxLink {
  /** Custom event emitter */
  eventChange!: IBoxLink['eventChange'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['eventChange']);
  }
}

import { Breadcrumbs as IBreadcrumbs } from '@imv/ui-kit/dist/types/components/breadcrumbs/component/breadcrumbs';
export declare interface ImvUiBreadcrumbs extends Components.ImvUiBreadcrumbs {}
@ProxyCmp({
  inputs: ['ariaLabel', 'fontSize', 'items', 'marginLeft', 'theme']
})
@Component({
  selector: 'imv-ui-breadcrumbs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['ariaLabel', 'fontSize', 'items', 'marginLeft', 'theme'],
  outputs: ['selected']
})
export class ImvUiBreadcrumbs {
  /**  */
  selected!: IBreadcrumbs['selected'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['selected']);
  }
}


export declare interface ImvUiButton extends Components.ImvUiButton {}
@ProxyCmp({
  inputs: ['ariaLabel', 'buttonTitle', 'class', 'disabled', 'eid', 'fullWidth', 'hrefLink', 'mobile', 'rel', 'relatedModal', 'size', 'target', 'theme', 'type', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['ariaLabel', 'buttonTitle', 'class', 'disabled', 'eid', 'fullWidth', 'hrefLink', 'mobile', 'rel', 'relatedModal', 'size', 'target', 'theme', 'type', 'variant']
})
export class ImvUiButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import { ImvUiCard as IImvUiCard } from '@imv/ui-kit/dist/types/components/card/component/card';
export declare interface ImvUiCard extends Components.ImvUiCard {}
@ProxyCmp({
  inputs: ['hasContent', 'literals', 'showErrors', 'size', 'srText', 'theme', 'variant']
})
@Component({
  selector: 'imv-ui-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['hasContent', 'literals', 'showErrors', 'size', 'srText', 'theme', 'variant'],
  outputs: ['clickTrash', 'clickEdit', 'openModal']
})
export class ImvUiCard {
  /**  */
  clickTrash!: IImvUiCard['clickTrash'];
  /**  */
  clickEdit!: IImvUiCard['clickEdit'];
  /**  */
  openModal!: IImvUiCard['openModal'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['clickTrash', 'clickEdit', 'openModal']);
  }
}

import { CheckboxList as ICheckboxList } from '@imv/ui-kit/dist/types/components/checkbox-list/component/checkbox-list';
export declare interface ImvUiCheckboxList extends Components.ImvUiCheckboxList {}
@ProxyCmp({
  inputs: ['disabled', 'eid', 'options', 'required', 'showErrors', 'theme', 'value', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-checkbox-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'eid', 'options', 'required', 'showErrors', 'theme', 'value', 'variant'],
  outputs: ['focusInput', 'blurInput', 'changeValue']
})
export class ImvUiCheckboxList {
  /**  */
  focusInput!: ICheckboxList['focusInput'];
  /**  */
  blurInput!: ICheckboxList['blurInput'];
  /**  */
  changeValue!: ICheckboxList['changeValue'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['focusInput', 'blurInput', 'changeValue']);
  }
}


export declare interface ImvUiCookiesBanner extends Components.ImvUiCookiesBanner {}
@ProxyCmp({
  inputs: ['acceptButtonText', 'buttonsVariant', 'rejectButtonText', 'theme'],
  methods: ['acceptCookies', 'rejectCookies']
})
@Component({
  selector: 'imv-ui-cookies-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['acceptButtonText', 'buttonsVariant', 'rejectButtonText', 'theme']
})
export class ImvUiCookiesBanner {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import { Header as IHeader } from '@imv/ui-kit/dist/types/components/header/component/header';
export declare interface ImvUiHeader extends Components.ImvUiHeader {}
@ProxyCmp({
  inputs: ['eid', 'home', 'imgList', 'items', 'link', 'text', 'type']
})
@Component({
  selector: 'imv-ui-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['eid', 'home', 'imgList', 'items', 'link', 'text', 'type'],
  outputs: ['clickImage']
})
export class ImvUiHeader {
  /**  */
  clickImage!: IHeader['clickImage'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['clickImage']);
  }
}

import { Input as IInput } from '@imv/ui-kit/dist/types/components/input/component/input';
export declare interface ImvUiInput extends Components.ImvUiInput {}
@ProxyCmp({
  inputs: ['class', 'disabled', 'dynamicStyle', 'eid', 'label', 'maxLength', 'optionalLabel', 'options', 'prefixText', 'required', 'selectedIndex', 'showErrors', 'tooltip', 'type', 'upperCase', 'value', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['class', 'disabled', 'dynamicStyle', 'eid', 'label', 'maxLength', 'optionalLabel', 'options', 'prefixText', 'required', 'selectedIndex', 'showErrors', 'tooltip', 'type', 'upperCase', 'value', 'variant'],
  outputs: ['blurInput', 'focusInput', 'changeValue']
})
export class ImvUiInput {
  /**  */
  blurInput!: IInput['blurInput'];
  /**  */
  focusInput!: IInput['focusInput'];
  /**  */
  changeValue!: IInput['changeValue'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['blurInput', 'focusInput', 'changeValue']);
  }
}

import { Jumbotron as IJumbotron } from '@imv/ui-kit/dist/types/components/jumbotron/component/jumbotron';
export declare interface ImvUiJumbotron extends Components.ImvUiJumbotron {}
@ProxyCmp({
  inputs: ['size', 'type', 'variant']
})
@Component({
  selector: 'imv-ui-jumbotron',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['size', 'type', 'variant'],
  outputs: ['eventChange']
})
export class ImvUiJumbotron {
  /** Custom event emitter */
  eventChange!: IJumbotron['eventChange'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['eventChange']);
  }
}

import { Modal as IModal } from '@imv/ui-kit/dist/types/components/modal/component/modal';
export declare interface ImvUiModal extends Components.ImvUiModal {}
@ProxyCmp({
  inputs: ['ariaDescribedby', 'isMobile', 'isOpen', 'persist', 'size', 'theme', 'type', 'variant'],
  methods: ['open', 'close']
})
@Component({
  selector: 'imv-ui-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['ariaDescribedby', 'isMobile', 'isOpen', 'persist', 'size', 'theme', 'type', 'variant'],
  outputs: ['closeModal']
})
export class ImvUiModal {
  /**  */
  closeModal!: IModal['closeModal'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['closeModal']);
  }
}


export declare interface ImvUiNote extends Components.ImvUiNote {}
@ProxyCmp({
  inputs: ['infoIcon', 'lessLabel', 'moreLabel', 'showMore', 'variant']
})
@Component({
  selector: 'imv-ui-note',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['infoIcon', 'lessLabel', 'moreLabel', 'showMore', 'variant']
})
export class ImvUiNote {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import { Panel as IPanel } from '@imv/ui-kit/dist/types/components/panel/component/panel';
export declare interface ImvUiPanel extends Components.ImvUiPanel {}
@ProxyCmp({
  inputs: ['detailOpened', 'eid', 'inSticky', 'showErrors', 'size', 'theme', 'titleLink', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['detailOpened', 'eid', 'inSticky', 'showErrors', 'size', 'theme', 'titleLink', 'variant'],
  outputs: ['accordionOpened', 'eventChange']
})
export class ImvUiPanel {
  /** CustomEvent para controlar la apertura del acordeon */
  accordionOpened!: IPanel['accordionOpen'];
  /** Custom event emitter */
  eventChange!: IPanel['eventChange'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['accordionOpened', 'eventChange']);
  }
}


export declare interface ImvUiProgressbar extends Components.ImvUiProgressbar {}
@ProxyCmp({
  inputs: ['isMobile', 'value']
})
@Component({
  selector: 'imv-ui-progressbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['isMobile', 'value']
})
export class ImvUiProgressbar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import { Rating as IRating } from '@imv/ui-kit/dist/types/components/rating/component/rating';
export declare interface ImvUiRating extends Components.ImvUiRating {}
@ProxyCmp({
  inputs: ['size', 'theme', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-rating',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['size', 'theme', 'variant'],
  outputs: ['eventChange', 'starRating']
})
export class ImvUiRating {
  /** Custom event emitter */
  eventChange!: IRating['eventChange'];
  /**  */
  starRating!: IRating['starRating'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['eventChange', 'starRating']);
  }
}

import { ReadOnly as IReadOnly } from '@imv/ui-kit/dist/types/components/read-only/component/read-only';
export declare interface ImvUiReadOnly extends Components.ImvUiReadOnly {}
@ProxyCmp({
  inputs: ['imgDownload', 'link', 'literals', 'required', 'size', 'text', 'theme', 'variant']
})
@Component({
  selector: 'imv-ui-read-only',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['imgDownload', 'link', 'literals', 'required', 'size', 'text', 'theme', 'variant'],
  outputs: ['eventChange', 'downloadFile']
})
export class ImvUiReadOnly {
  /** Custom event emitter */
  eventChange!: IReadOnly['eventChange'];
  /**  */
  downloadFile!: IReadOnly['downloadFile'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['eventChange', 'downloadFile']);
  }
}

import { SelectorList as ISelectorList } from '@imv/ui-kit/dist/types/components/selector-list/component/selector-list';
export declare interface ImvUiSelectorList extends Components.ImvUiSelectorList {}
@ProxyCmp({
  inputs: ['autoFocus', 'disabled', 'dynamicStyle', 'options', 'required', 'showErrors', 'textLeft', 'type', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-selector-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['autoFocus', 'disabled', 'dynamicStyle', 'options', 'required', 'showErrors', 'textLeft', 'type', 'variant'],
  outputs: ['valueChange', 'changeValue', 'focusInput', 'blurInput', 'selected', 'kDown']
})
export class ImvUiSelectorList {
  /**  */
  valueChange!: ISelectorList['valueChange'];
  /**  */
  changeValue!: ISelectorList['changeValue'];
  /**  */
  focusInput!: ISelectorList['focusInput'];
  /**  */
  blurInput!: ISelectorList['blurInput'];
  /**  */
  selected!: ISelectorList['selected'];
  /**  */
  kDown!: ISelectorList['kDown'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['valueChange', 'changeValue', 'focusInput', 'blurInput', 'selected', 'kDown']);
  }
}

import { SelectorMultiple as ISelectorMultiple } from '@imv/ui-kit/dist/types/components/selector-multiple/component/selector-multiple';
export declare interface ImvUiSelectorMultiple extends Components.ImvUiSelectorMultiple {}
@ProxyCmp({
  inputs: ['disabled', 'dynamicStyle', 'eid', 'label', 'multipleSelectText', 'optionalLabel', 'options', 'showErrors', 'theme', 'value', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-selector-multiple',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'dynamicStyle', 'eid', 'label', 'multipleSelectText', 'optionalLabel', 'options', 'showErrors', 'theme', 'value', 'variant'],
  outputs: ['changeValue', 'blurInput', 'focusInput']
})
export class ImvUiSelectorMultiple {
  /**  */
  changeValue!: ISelectorMultiple['changeValue'];
  /**  */
  blurInput!: ISelectorMultiple['blurInput'];
  /**  */
  focusInput!: ISelectorMultiple['focusInput'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['changeValue', 'blurInput', 'focusInput']);
  }
}

import { Signature as ISignature } from '@imv/ui-kit/dist/types/components/signature/component/signature';
export declare interface ImvUiSignature extends Components.ImvUiSignature {}
@ProxyCmp({
  inputs: ['disabled', 'optionalLabel', 'showErrors', 'theme', 'value', 'variant']
})
@Component({
  selector: 'imv-ui-signature',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'optionalLabel', 'showErrors', 'theme', 'value', 'variant'],
  outputs: ['signatureSubmitted', 'changeValue', 'removeFile']
})
export class ImvUiSignature {
  /**  */
  signatureSubmitted!: ISignature['signatureSubmitted'];
  /**  */
  changeValue!: ISignature['changeValue'];
  /**  */
  removeFile!: ISignature['removeFile'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['signatureSubmitted', 'changeValue', 'removeFile']);
  }
}

import { Snackbar as ISnackbar } from '@imv/ui-kit/dist/types/components/snackbar/component/snackbar';
export declare interface ImvUiSnackbar extends Components.ImvUiSnackbar {}
@ProxyCmp({
  inputs: ['buttonText', 'timeout', 'variant'],
  methods: ['open', 'close']
})
@Component({
  selector: 'imv-ui-snackbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['buttonText', 'timeout', 'variant'],
  outputs: ['buttonClicked']
})
export class ImvUiSnackbar {
  /**  */
  buttonClicked!: ISnackbar['buttonClicked'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['buttonClicked']);
  }
}


export declare interface ImvUiSteps extends Components.ImvUiSteps {}
@ProxyCmp({
  inputs: ['first', 'literals', 'size', 'steps', 'theme', 'variant']
})
@Component({
  selector: 'imv-ui-steps',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['first', 'literals', 'size', 'steps', 'theme', 'variant']
})
export class ImvUiSteps {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface ImvUiTooltip extends Components.ImvUiTooltip {}
@ProxyCmp({
  inputs: ['eid', 'fieldset', 'text'],
  methods: ['onViewportChanges']
})
@Component({
  selector: 'imv-ui-tooltip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['eid', 'fieldset', 'text']
})
export class ImvUiTooltip {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import { UploadFile as IUploadFile } from '@imv/ui-kit/dist/types/components/upload-file/component/upload-file';
export declare interface ImvUiUploadFile extends Components.ImvUiUploadFile {}
@ProxyCmp({
  inputs: ['acceptedFiles', 'disabled', 'eid', 'errorMaxSize', 'errorType', 'fileError', 'fileUploaded', 'files', 'maxFiles', 'maxReached', 'maxSize', 'minError', 'minFiles', 'nameSizeError', 'optionalLabel', 'placeholder', 'readOnly', 'showErrors', 'theme', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-upload-file',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['acceptedFiles', 'disabled', 'eid', 'errorMaxSize', 'errorType', 'fileError', 'fileUploaded', 'files', 'maxFiles', 'maxReached', 'maxSize', 'minError', 'minFiles', 'nameSizeError', 'optionalLabel', 'placeholder', 'readOnly', 'showErrors', 'theme', 'variant'],
  outputs: ['changeValue', 'removeFile', 'downloadFile', 'openFileNewTab', 'focusFile']
})
export class ImvUiUploadFile {
  /**  */
  changeValue!: IUploadFile['changeValue'];
  /**  */
  removeFile!: IUploadFile['removeFile'];
  /**  */
  downloadFile!: IUploadFile['downloadFile'];
  /**  */
  openFileNewTab!: IUploadFile['openFileNewTab'];
  /**  */
  focusFile!: IUploadFile['focusFile'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['changeValue', 'removeFile', 'downloadFile', 'openFileNewTab', 'focusFile']);
  }
}

import { UploadImage as IUploadImage } from '@imv/ui-kit/dist/types/components/upload-image/component/upload-image';
export declare interface ImvUiUploadImage extends Components.ImvUiUploadImage {}
@ProxyCmp({
  inputs: ['acceptedFiles', 'disabled', 'eid', 'errorMaxSize', 'errorNameSize', 'errorType', 'fileError', 'fileUploaded', 'maxSize', 'optionalLabel', 'showErrors', 'value'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-upload-image',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['acceptedFiles', 'disabled', 'eid', 'errorMaxSize', 'errorNameSize', 'errorType', 'fileError', 'fileUploaded', 'maxSize', 'optionalLabel', 'showErrors', 'value'],
  outputs: ['changeValue', 'removeFile', 'focusUploadFile']
})
export class ImvUiUploadImage {
  /**  */
  changeValue!: IUploadImage['changeValue'];
  /**  */
  removeFile!: IUploadImage['removeFile'];
  /**  */
  focusUploadFile!: IUploadImage['focusUploadFile'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['changeValue', 'removeFile', 'focusUploadFile']);
  }
}

import { Videoidentification as IVideoidentification } from '@imv/ui-kit/dist/types/components/videoidentification/component/videoidentification';
export declare interface ImvUiVideoidentification extends Components.ImvUiVideoidentification {}
@ProxyCmp({
  inputs: ['buttonDisabled', 'cameraError', 'cameraLayer', 'eid', 'helpFooter', 'hideButton', 'optionalLabel', 'showErrors', 'takeOther', 'theme', 'value', 'variant'],
  methods: ['setFocus']
})
@Component({
  selector: 'imv-ui-videoidentification',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['buttonDisabled', 'cameraError', 'cameraLayer', 'eid', 'helpFooter', 'hideButton', 'optionalLabel', 'showErrors', 'takeOther', 'theme', 'value', 'variant'],
  outputs: ['noCameraClicked', 'changeValue', 'used']
})
export class ImvUiVideoidentification {
  /**  */
  noCameraClicked!: IVideoidentification['noCameraClicked'];
  /**  */
  changeValue!: IVideoidentification['changeValue'];
  /**  */
  used!: IVideoidentification['used'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['noCameraClicked', 'changeValue', 'used']);
  }
}
